import { Button, Modal, Tooltip, useLocale } from 'shared-ui';

import { AppMessages } from 'i18n/messages';

import { ReportModalProps } from './ReportModal.types';
import * as Styled from './ReportModal.styles';

export const ReportModal = (props: ReportModalProps) => {
  const { formatMessage } = useLocale();

  return (
    <Modal type="default" {...props}>
      <div>{props.children}</div>

      <Styled.Footer>
        <Button variant="text" onClick={props.onClose} size="small">
          {formatMessage({ id: AppMessages['common.cancel'] })}
        </Button>
        <Tooltip
          title={props.isSendButtonDisabled ? formatMessage({ id: AppMessages['reports.serverNotConfigured'] }) : ''}
          placement="top"
          arrow
        >
          <span>
            <Button variant="outlined" onClick={props.onSend} size="small" disabled={props.isSendButtonDisabled}>
              {formatMessage({ id: AppMessages['common.send'] })}
            </Button>
          </span>
        </Tooltip>
        <Button variant="contained" onClick={props.onDownload} size="small" disabled={props.isDownloadButtonDisabled}>
          {formatMessage({ id: AppMessages['common.download'] })}
        </Button>
      </Styled.Footer>
    </Modal>
  );
};
